import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export default StyleSheet.create({
  container: {
    flexGrow: 1,
    gap: 24,
    padding: 16,
    backgroundColor: themes.light.white[1],
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  hero: {
    width: 343,
    height: 120,
    marginVertical: 24,
  },
  title: {
    width: '100%',
    fontWeight: '700',
    marginBottom: 16,
    textAlign: 'center',
  },
  priceRange: {
    marginBottom: 16,
    textAlign: 'center',
  },
  subtext: {
    marginBottom: 32,
    textAlign: 'center',
    color: themes.light.brand_blue[3],
  },
  actions: {
    width: '100%',
    marginTop: 'auto',
    marginBottom: 16,
  },
  ctaButton: {
    width: '100%',
  },
});
